import config from 'config';

export const toAbsoluteAuthUrl = url => {
  return `${config.authBaseUrl}${url}`;
};

export const shortenUrl = (urlString: string, pathLength = 20) => {
  if (!urlString) {
    return null;
  }

  let url: URL;
  try {
    url = new URL(urlString);
  } catch (e) {
    return null;
  }

  const baseUrl = url.origin;
  const path = url.toString().slice(baseUrl.length);

  return !path || path.length <= pathLength
    ? urlString
    : `${baseUrl}/...${path.slice(-pathLength)}`;
};
